const taskManagerHu = {
	taskManagerTable: 'Task Manager',
	taskManagerEditForm: 'Task Manager',
	name: 'Name',
	status: 'Status',
	type: 'Type',
	ts: 'Timestamp',
	result: 'Result',
	error: 'Error',
	user_name: 'Username',
	message: 'Message',
	ts_result: 'Result Timestamp',
	fileCount: 'Files',
	enabled: 'Enabled',
	schedule: 'Schedule',
	okCount: 'OK Count',
	failCount: 'Fail Count',
	lastStarted: 'Last Started',
	lastStatus: 'Last Status',
	lastTimestamp: 'Last Timestamp',
	lastMessage: 'Last Message',
	lastResult: 'Last Result',
	last_date_time: 'Last Date Time',
	reader: 'Reader',
	measurement: 'Measurement',
	startDateTime: 'Start Date Time',
	endDateTime: 'End Date Time',
	'schedule.minute': 'Minute',
	'schedule.hour': 'Hour',
	'schedule.day': 'Day',
	'schedule.month': 'Month',
	deleteTimeFromTs: 'Delete Time From TS',
	skipRowsWithNullValues: 'Skip rows with null values',
	addOrUpdate: 'Add or Update',
	outlierDetector: 'Outlier Detector',
	outlierDetectors: 'Outlier Detectors',
	inputMeasurement: 'Input Measurement',
	inputMeasurements: 'Input Measurements',
	outputMeasurement: 'Output Measurement',
	outlierRemoval: 'Outlier Removal',
	skewnessCorrection: 'Skewness Correction',
	dataset: 'Dataset',
	aspect: 'Aspect',
	tolerance: 'Tolerance',
	optimizationCase: 'Optimization case',
	optimizers: 'Optimizers',
	unitOptimizer: 'Unit optimizer',
	deleteFromOutput: 'Delete from output',
	backfill: 'Backfill',
	modelValidationLog: 'Model validation log',
	navigate: 'Navigate',
	timeWindowInDays: 'Time window in days',
	duplicateLastValueIfMissing: 'Duplicate last value if missing',
	sortComponents: 'Sort components',
	stateInjectName: 'Name',
	statInjectValue: 'Value',
	optimizationPipeline: 'Optimization Pipeline',
	'user.name': 'User',
	'state.last_date_time': 'Last Date Time',
	modelValidation: 'Model Validation',
	piMeasurementReaderTasks: 'PI Measurement Reader Tasks',
	labMeasurementReaderTasks: 'Lab Measurement Reader Tasks',
	measurementMergeTask: 'Measurement Merge Task',
	outlierDetectionTask: 'Outlier Detection Task',
	dataCleanTask: 'Data Clean Task',
	modelValidationTask: 'Model Validation Task',
	unitOptimizerTask: 'Unit Optimizer Task',
	optimizationPipelineLog: 'Optimization Pipeline Log',
	simulationMonitor: 'Simulation Monitor',
	piWriter: 'Pi Writer',
	userGroup: 'User Group',
	summaryDuration: 'Summary Duration',
	summaryDurationUnit: 'Summary Duration Unit',
	summaryType: 'Summary Type',
	edtDynamicCheck: 'EDT Dynamic Check',
};

export default taskManagerHu;